
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","width":"26","height":"26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 4v42h50V4zm2 2h46v38H2zm2 2v22.688L17.313 18.28c.195-.183.457-.308.718-.281.266.012.54.117.719.313l10.281 11.25 4.25-4.282c.39-.39 1.047-.39 1.438 0L46 36.594V8zm31 7a3 3 0 11-.002 6.002A3 3 0 0135 15zm-17.063 5.406L4 33.438V42h42v-2.594l-12-12L26.406 35h-2.812l4.031-4.031z"}})])
          )
        }
      }
    